import qs from "qs";
/*
 * 订单确认
 * */
import request from "@utils/request";

/**
 * 通过购物车 id 确认下单
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(cartId) {
  return request.post("/wap/order/confirm", cartId);
}

/**
 * 计算订单金额
 * @param key
 * @param data
 * @returns {*}
 */
export function postOrderComputed(data) {
  return request.post("/wap/order/computed", data);
}

/**
 * 获取指定金额可用优惠券
 * @param price
 * @returns {*}
 */
export function getOrderCoupon(price) {
  return request.post("/wap/coupons/order/" + (parseFloat(price) || 0));
}

/**
 * 生成订单
 * @param data
 * @returns {*}
 */
export function createOrder(data) {
  return request.post("/wap/order/create", data || {});
}

/**
 * 创建新订单
 * @param data
 * @returns {*}
 */
export function newOrder(data) {
  return request.post("/wap/order/new", data || {});
}

/**
 * 订单统计数据
 * @returns {*}
 */
export function getOrderData() {
  return request.get("/wap/order/data");
}

/**
 * 订单列表
 * @returns {*}
 */
export function getOrderList(data) {
  return request.get("/wap/order/list", data);
}

/**
 * 取消订单
 * @returns {*}
 */
export function cancelOrder(id) {
  return request.post("/wap/order/cancel/" + id);
}

/**
 * 订单详情
 * @returns {*}
 */
export function orderDetail(id) {
  return request.get("/wap/order/detail/" + id);
}
/**
 * 订单评论
 * @returns {*}
 */
export function orderReply(orderId) {
  return request.get(`/wap/product/view/${orderId}`);
}

/**
 * 退款理由
 * @returns {*}
 */
export function getRefundReason() {
  return request.get("/wap/order/refund/reason");
}

/**
 * 提交退款
 * @returns {*}
 */
export function postOrderRefund(data) {
  return request.post("/wap/order/refund/verify", data);
}

/**
 * 确认收货
 * @returns {*}
 */
export function takeOrder(uni) {
  return request.post("/wap/order/take/" + uni);
}

/**
 * 删除订单
 * @returns {*}
 */
export function delOrder(uni) {
  return request.post("/order/del", { uni });
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function express(uni) {
  return request.get("/wap/order/express/" + uni);
}

/**
 * 订单支付
 * @returns {*}
 */
export function payOrder(orderId, paytype, from) {
  return request.post(
    "/wap/order/pay/" + orderId,
    qs.stringify({ paytype, from })
  );
}
/**
 * 用户签字
 * @returns {*}
 */
export function signOrder(orderId, sign) {
  return request.post(
    `/wap/order/sign/${orderId}`,
    qs.stringify({ picture: sign })
  );
}
/**
 * 订单核销
 * @returns {*}
 */
export function orderVerific(verify_code, is_confirm) {
  return request.post("order/order_verific", { verify_code, is_confirm });
}

/**
 * 获取订单员工评价信息（是否已评价及评价内容）
 * @param orderId
 * @returns {*}
 */
export function fetchReviewView(orderId) {
  return request.get("/review/h5/view/" + orderId);
}

/**
 * 提交员工评价（环境卫生 + 各技师手艺/服务态度）
 * @param data
 * @returns {*}
 */
export function postReviewSave(data) {
  return request.post("/review/h5/save", data);
}
